"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONBOARDING_CURRENT_DOCUMENT_DETAILS = exports.ONBOARDING_DOCUMENT_UIDS = exports.hardcodedOnboardingProjectSets = exports.AllOnboardingProjectSets = exports.currentOnboardingProjectSets = exports.copilotFocusWithoutCommentsOnboardingProjectSet = exports.historicalOnboardingProjectSet = exports.defaultOnboardingProjectSet = exports.OnboardingProjectSetsPartialFromList = exports.OnboardingProjectSets = exports.OnboardingProjectSetList = exports.OnboardingProjectSet = exports.alwaysAvailableProjectSetNames = exports.OnboardingProjectSetName = exports.OnboardingProject = exports.EditorView = exports.EditorViewSchema = void 0;
exports.findExampleProject = findExampleProject;
exports.findExampleProjectWithTag = findExampleProjectWithTag;
const zod_1 = require("zod");
/*
  TODO: We need to unify all this editor mode string craziness.
 */
exports.EditorViewSchema = zod_1.z.enum(["schematic", "code", "pcb", "pcb_2d", "pcb_3d", "doc"]);
exports.EditorView = exports.EditorViewSchema.enum;
exports.OnboardingProject = zod_1.z.object({
    uid: zod_1.z.string(),
    name: zod_1.z.string().optional(),
    tags: zod_1.z.array(zod_1.z.string()).default([]),
    openToView: exports.EditorViewSchema.default(exports.EditorView.schematic),
    description: zod_1.z.string().optional(),
    preview_image: zod_1.z.string().optional(),
    comment: zod_1.z.string().optional(),
});
exports.OnboardingProjectSetName = zod_1.z.string();
const alwaysAvailableNames = ["_default", "_historical"];
exports.alwaysAvailableProjectSetNames = Object.fromEntries(alwaysAvailableNames.map((name) => [name, name]));
exports.OnboardingProjectSet = zod_1.z.object({
    name: exports.OnboardingProjectSetName,
    aka: zod_1.z.array(exports.OnboardingProjectSetName).optional(),
    comment: zod_1.z.string().optional(),
    projects: zod_1.z.array(exports.OnboardingProject),
});
const withName = zod_1.z
    .object({
    set: exports.OnboardingProjectSet,
    name: zod_1.z.string(),
})
    .transform(({ set, name }) => ({
    ...set,
    name,
    aka: [...(set.aka ?? []), name],
}));
exports.OnboardingProjectSetList = zod_1.z.array(exports.OnboardingProjectSet);
exports.OnboardingProjectSets = zod_1.z
    .object({
    [exports.alwaysAvailableProjectSetNames._default]: exports.OnboardingProjectSet,
    [exports.alwaysAvailableProjectSetNames._historical]: exports.OnboardingProjectSet,
})
    .catchall(exports.OnboardingProjectSet);
exports.OnboardingProjectSetsPartialFromList = exports.OnboardingProjectSetList.transform((input) => input.reduce((acc, set) => {
    acc[set.name] = withName.parse({ set, name: set.name });
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    set.aka?.forEach((name) => (acc[name] = withName.parse({ set, name })));
    return acc;
}, exports.OnboardingProjectSets.partial().parse({}))).pipe(exports.OnboardingProjectSets.partial());
exports.defaultOnboardingProjectSet = exports.OnboardingProjectSet.parse({
    name: exports.alwaysAvailableProjectSetNames._default,
    aka: ["control", "off", "legacy"],
    comment: "Fallback document set.",
    projects: [
        {
            uid: "99194457-ea20-4fe5-82f7-548e43934495",
            comment: "https://flux.ai/example-user/example-arduino-mkr-memory-shield",
        },
        {
            uid: "220dddb2-3bdf-4b69-9e5c-63efd601cdef",
            comment: "https://flux.ai/example-user/example-arduino-mkr-shield-template",
        },
        {
            uid: "d82e14e7-c07a-40dd-9633-e0602c3cb552",
            comment: "https://flux.ai/example-user/example-simulation-of-astable-multivibrator-circuit",
        },
        {
            uid: "d4de54f8-e5d5-4fee-80d8-c62e7b92a134",
            comment: "https://flux.ai/example-user/example-led-simulator-template",
        },
    ],
});
exports.historicalOnboardingProjectSet = exports.OnboardingProjectSet.parse({
    name: exports.alwaysAvailableProjectSetNames._historical,
    comment: "Defunct document set used only for reference.",
    projects: [
        { uid: "27ce13c9-8366-de6c-c57b-9ec4f8dc2790" },
        { uid: "2719b68a-9eb9-00be-8de8-13c4de7c88ae" },
        { uid: "b190940b-44d1-53a3-9209-21d0eaca1b7b" },
        { uid: "cc57ab8d-d921-9d12-3faf-1d743d93e39d" },
        { uid: "e55e111d-9bf8-b938-022a-a4397ca973a3" },
        { uid: "efc861fd-cc96-434f-bfed-6abc4d9ea9ee", comment: "brainstorm-a-new-project-with-ai-example" },
        { uid: "689303c9-5fef-4c0a-a64d-4d9dd3693db6", comment: "brainstorm-a-new-project-with-ai-example-rb4dn" },
    ],
});
exports.copilotFocusWithoutCommentsOnboardingProjectSet = exports.OnboardingProjectSet.parse({
    name: "copilot-focus-without-comments",
    comment: "Copilot focused projects.",
    projects: [
        {
            uid: "b121e773-3b90-468b-b635-33b5a5c200d5",
            openToView: exports.EditorView.pcb_2d,
            comment: "https://www.flux.ai/example-user/esprsso32-smart-scale-ai-auto-layout-example",
        },
        {
            uid: "0a67ff27-fcce-4426-b548-b4e15d5e8da9",
            comment: "https://flux.ai/example-user/esp32-robot-controller-or-ai-design-review-tutorial-example",
        },
        {
            uid: "3d04994c-5e98-490f-b700-5bfa94925884",
            comment: "https://flux.ai/example-user/raspberry-pi-pico-or-end-to-end-ai-design-tutorial-example",
        },
        {
            uid: "5d4edec3-a6b1-48c8-a86a-8143c269b480",
            comment: "https://flux.ai/example-user/tesla-vehicle-display-system-or-ai-cost-optimization-tutorial-example",
        },
    ],
});
exports.currentOnboardingProjectSets = exports.OnboardingProjectSetList.parse([
    exports.copilotFocusWithoutCommentsOnboardingProjectSet,
    {
        name: "copilot-focus-with-comments",
        comment: "Copilot focused projects with example comments.",
        projects: [
            {
                uid: "b121e773-3b90-468b-b635-33b5a5c200d5",
                openToView: exports.EditorView.pcb_2d,
                comment: "https://www.flux.ai/example-user/esprsso32-smart-scale-ai-auto-layout-example",
            },
            {
                uid: "bf73689f-11c0-40fd-b97d-fdc346519d31",
                comment: "https://flux.ai/example-user/esp32-robot-controller-or-ai-design-review-tutorial-example-oym89",
            },
            {
                uid: "aa61c8ff-4299-4ac1-a4bf-7c4ec8e0c06a",
                comment: "https://flux.ai/example-user/raspberry-pi-pico-or-end-to-end-ai-design-tutorial-example-cafcw",
            },
            {
                uid: "88d9813a-f83c-4c30-9321-50a901ccef7d",
                comment: "https://flux.ai/example-user/tesla-vehicle-display-system-or-ai-cost-optimization-tutorial-example-ftv2s",
            },
        ],
    },
]);
/*
 * These are example projects specifically designed for use with feature announcements,
 * so this set will be added to over time as we create and announce new features.
 * This set won't be directly used as a user's signup project set, although some of these may be included
 * in those other sets that users will get.
 */
const featureAnnouncementExampleSet = exports.OnboardingProjectSetList.parse([
    {
        name: "_feature_announcement",
        comment: "For use with feature announcements.",
        projects: [
            {
                uid: "b121e773-3b90-468b-b635-33b5a5c200d5",
                tags: ["AutoLayoutDialogExample"],
                openToView: exports.EditorView.pcb_2d,
                comment: "https://www.flux.ai/example-user/esprsso32-smart-scale-ai-auto-layout-example",
            },
        ],
    },
]);
/*
 * Use this project set for testing or when the sets should not be overridden by LaunchDarkly feature flags.
 */
const nonOverridableProjectSets = exports.OnboardingProjectSetList.parse([]);
exports.AllOnboardingProjectSets = exports.OnboardingProjectSetList.nullable()
    .optional()
    .transform((additional) => exports.OnboardingProjectSetsPartialFromList.pipe(exports.OnboardingProjectSets).parse([
    exports.defaultOnboardingProjectSet,
    exports.historicalOnboardingProjectSet,
    ...exports.currentOnboardingProjectSets,
    ...featureAnnouncementExampleSet,
    ...(additional ?? []),
    ...nonOverridableProjectSets,
]));
exports.hardcodedOnboardingProjectSets = exports.AllOnboardingProjectSets.parse([]);
/**
 * A list of all onboarding documents we've ever used
 *
 * Use this when checking whether a document should be considered an "example document".
 *
 * TODO:  We will not be able to rely on a static list of uids to determine onboarding project provenance, since the
 *        project sets will soon be stored externally (in LaunchDarkly, our feature-flagging system).
 *        We will need to either store metadata on the cloned document itself, marking it as an onboarding freebie, or
 *        capture the set of onboarding documents that were used when creating a particular user at the time of sign-up,
 *        and then reference that per-user while performing operations that need to distinguish.
 *
 * @deprecated We will soon not be able to rely on a static list of uids to determine onboarding project provenance
 */
exports.ONBOARDING_DOCUMENT_UIDS = Object.values(exports.hardcodedOnboardingProjectSets).flatMap((set) => set.projects.map((doc) => doc.uid));
/**
 * These are the ACTIVE onboarding documents, that we'll create new projects from.
 *
 * Don't use these to check whether a document is an onboarding document, because it won't understand
 * previously-active (historical) onboarding documents (the list of UIDs has changed over time). Instead, use
 * ONBOARDING_DOCUMENT_UIDS for that task.
 *
 * When changing this list, you MUST copy any UIDs that you remove to the ONBOARDING_DOCUMENT_UIDS_HISTORICAL list
 * below, so that we can grandfather in previously created example documents when e.g. counting or computing content
 * scores
 *
 * @deprecated We will soon not be able to rely on a static list of uids to determine onboarding project provenance
 */
exports.ONBOARDING_CURRENT_DOCUMENT_DETAILS = exports.defaultOnboardingProjectSet.projects.map((doc) => doc.uid);
/**
 * Finds the first OnboardingProject with the provided uid project within the provided OnboardingProjectSets.
 * @param allExampleProjects - The OnboardingProjectSets object containing all project sets.
 * @param projectUid - The uid of the project to search for.
 * @returns The OnboardingProject value if a matching project is found; otherwise, undefined.
 */
function findExampleProject(allExampleProjects, projectUid) {
    for (const projectSet of Object.values(allExampleProjects)) {
        const matchingProject = projectSet.projects.find((project) => project.uid === projectUid);
        if (matchingProject) {
            return matchingProject;
        }
    }
    return undefined;
}
/**
 * Finds the first OnboardingProject tagged with the provided string the provided OnboardingProjectSets.
 * @param allExampleProjects - The OnboardingProjectSets object containing all project sets.
 * @param projectUid - The uid of the project to search for.
 * @returns The OnboardingProject value if a matching project is found; otherwise, undefined.
 */
function findExampleProjectWithTag(allExampleProjects, tag) {
    for (const projectSet of Object.values(allExampleProjects)) {
        const matchingProject = projectSet.projects.find((project) => project.tags.includes(tag));
        if (matchingProject) {
            return matchingProject;
        }
    }
    return undefined;
}
//# sourceMappingURL=onboardingExampleDocuments.js.map